import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import qs from 'qs'

import {
  NotGroupedContainer,
  GroupHeaderContainer,
  GroupHeaderFirstLine,
  GroupNameDisplay,
  GroupHeaderStudentNames,
  NotGroupedMessage,
} from './styled'

const STANDARDS_PERFORMANCE_SUMMARY_PATH =
  '/author/reports/standards-performance-summary'

const NotGroupedSection = ({
  notGroupedStudents,
  selectedCurriculumId = null,
  selectedProfileId = null,
  standardsMasteryReportLinkContext = null,
}) => {
  const studentNamesStr =
    (notGroupedStudents || [])
      .map((s) => s.name || s.studentName || '')
      .filter(Boolean)
      .join(', ') || '—'

  const standardsMasteryReportTo = useMemo(() => {
    const ctx = standardsMasteryReportLinkContext
    const query = {}
    if (ctx?.termId) query.termId = ctx.termId
    if (ctx?.classId) {
      query.classIds = String(ctx?.classId)
    }
    if (selectedCurriculumId) {
      query.curriculumId = String(selectedCurriculumId)
    }
    if (selectedProfileId) {
      query.profileId = String(selectedProfileId)
    }
    const search = Object.keys(query).length ? `?${qs.stringify(query)}` : ''
    return `${STANDARDS_PERFORMANCE_SUMMARY_PATH}${search}`
  }, [
    standardsMasteryReportLinkContext,
    selectedCurriculumId,
    selectedProfileId,
  ])

  return (
    <NotGroupedContainer>
      <GroupHeaderContainer style={{ cursor: 'default', paddingRight: 0 }}>
        <GroupHeaderFirstLine>
          <GroupNameDisplay style={{ cursor: 'default' }}>
            <b>Not Grouped</b>
          </GroupNameDisplay>
        </GroupHeaderFirstLine>
        {studentNamesStr && studentNamesStr !== '—' && (
          <GroupHeaderStudentNames>{studentNamesStr}</GroupHeaderStudentNames>
        )}
      </GroupHeaderContainer>
      <NotGroupedMessage>
        Not enough data to determine mastery yet. View the{' '}
        <Link to={standardsMasteryReportTo}>Standards mastery report</Link> for
        more details.
      </NotGroupedMessage>
    </NotGroupedContainer>
  )
}

export default NotGroupedSection
